module.exports = __webpack_public_path__ + "img/title3.82bb2b04.png";